// src/modules/app-views/_apps/appsindico/parkingSpots/pages/Init/actions/actionButton.js

import { PlusOutlined } from '@ant-design/icons';

const parkingSpotsInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_parking_spot',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ navigate, setPage }) => {
      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },
    dropdownItems: [],
  };
};

export default parkingSpotsInitActionButton;
